import { Axios, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

export default (axios: Axios): void => {
    axios.interceptors.request.use(
        (config: InternalAxiosRequestConfig) => {
            return config;
        },
        (err: any) => {
            return Promise.reject(err);
        }
    );
    axios.interceptors.response.use(
        (res: AxiosResponse) => {
            let result = null;
            if (res.config) {
                result = res.data;
            }
            return result;
        },
        (err: any) => {
            return Promise.reject(err);
        }
    );
};
